import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import ErrorIcon from '@material-ui/icons/Error';
import WarningIcon from '@material-ui/icons/Warning';
import Alert from '@material-ui/lab/Alert';

import BatteryInfo from './BatteryInfo';
import DeviceStatus from './DeviceStatus';

const ALERT_MESSAGES = {
  1: 'Low battery',
  2: 'Critically low battery',
  3: 'Signal strength low',
  4: 'Has not updated lately',
  5: 'Inconsistent updates',
  6: 'Monitor is not sending current information',
  7: 'Alert is present on the current monitor',
};

const useStyles = makeStyles(() => ({
  high: {
    fill: '#E04828',
  },
  highLight: {
    backgroundColor: '#F8DAD4',
    width: '100%',
  },
  med: {
    fill: '#FFCB75',
  },
  medLight: {
    backgroundColor: '#FFF4E3',
    width: '100%',
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    paddingLeft: 5,
  },
}));

const ErrorInfo = ({ status, errorText, showText }) => {
  const classes = useStyles();
  const [errorIcon, setErrorIcon] = useState();
  const [alertColor, setAlertColor] = useState();
  const [errorMessage, setErrorMessage] = useState(errorText);

  useEffect(() => {
    switch (status) {
      case 0:
        break;
      case 1:
        setErrorIcon(<BatteryInfo battery={35} />);
        setAlertColor(classes.medLight);
        break;
      case 2:
        setErrorIcon(<BatteryInfo battery={15} />);
        setAlertColor(classes.highLight);
        break;
      case 3:
        setErrorIcon(<DeviceStatus status={1} />);
        setAlertColor(classes.medLight);
        break;
      case 4:
        setErrorIcon(<ErrorIcon className={classes.high} />);
        setAlertColor(classes.highLight);
        break;
      case 5:
        setErrorIcon(<WarningIcon className={classes.med} />);
        setAlertColor(classes.medLight);
        break;
      case 6:
        setErrorIcon(<WarningIcon className={classes.med} />);
        setAlertColor(classes.medLight);
        break;
      case 7:
        setErrorIcon(<ErrorIcon className={classes.high} />);
        setAlertColor(classes.highLight);
        break;
      default:
        break;
    }
    setErrorMessage(errorText || ALERT_MESSAGES[status]);
  }, [status, errorText]);

  if (showText) {
    return (
      <Alert className={alertColor} icon={errorIcon}>
        {errorMessage}
      </Alert>
    );
  }
  return <div>{errorIcon}</div>;
};

ErrorInfo.propTypes = {
  status: PropTypes.number.isRequired,
  errorText: PropTypes.string,
  showText: PropTypes.bool,
};
ErrorInfo.defaultProps = {
  showText: false,
  errorText: '',
};

export default ErrorInfo;
